module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "LogTags", "Filter log tags" ) ))==null?'':__t)+
'</legend><span class="label">'+
((__t=( i18n.tc( "LogTags", "Tags:" ) ))==null?'':__t)+
'</span><div class="input" data-container="checkbox-array"></div></fieldset><fieldset class="button-wrap"><button data-click="tags-cancel">'+
((__t=( i18n.tc( "LogEntryCreate", "Cancel" ) ))==null?'':__t)+
'</button> <button class="primary" data-click="tags-submit" disabled="disabled">'+
((__t=( i18n.tc( "LogTags", "Apply filter" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
